<template lang="pug">
  #listServiceState
    .table-view-header
      .table-view-header-title
        h3 Estados del servicio
      .table-view-header-actions
        b-button(@click="showCreateModal" size="sm" variant ="secondary") + Nuevo
    b-table(:items="tableItems" head-row-variant="light-primary" responsive)
      template(v-slot:cell(Color)="data")
        #color(v-if="data.value.color")
          span(:style="data.value.color")
          p {{ data.value.color.title }}
      template(v-slot:cell(Acciones)="data")
        .table-actions
          b-button(@click="showEditModal(data.value.state)", size="sm", variant="muted") Editar
          b-button.tableButton(@click="showDeleteModal(data.value.state)", size="sm", variant="danger") Eliminar
    //- Modals
    b-modal(v-model="showCreate", :hide-footer="true", title="Crear estado para servicio" no-close-on-backdrop)
      CreateEditForm(v-if="showCreate", :hideModal="hideCreateModal", action="Crear", :makeToast="makeToast") 
    b-modal(v-model="showEdit", :hide-footer="true", title="Editar estado de servicio" no-close-on-backdrop)
      CreateEditForm(v-if="showEdit", title="Editar estado", action="Editar", :hideModal="hideEditModal", :selected="selected", :makeToast="makeToast")
    b-modal(v-model="showDelete", :hide-footer="true", :hide-header="true" no-close-on-backdrop)
      DeleteState(v-if="showDelete", :hideModal="hideDeleteModal", :selected="selected", :makeToast="makeToast")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import CreateEditForm from './CreateEditForm';
import DeleteState from './DeleteState';
import stateColors from "../../../shared/state_colors.json";
export default {
  components: {
    CreateEditForm,
    DeleteState
  },
  data() {
    return {
      showCreate: false,
      showEdit: false,
      showDelete: false,
      selected: {}
    }
  },
  computed: {
    ...mapGetters(['service']),
    tableItems() {
      if(this.service.states) {
        return this.service.states.map((s) => {
          return {
            'Nombre': s.name,
            'Color': { color: this.setColorCell(s.color) },
            'Orden': s.order,
            '% de progreso': s.pctProgress,
            'Acciones': { state: s }
            
          }
        });
      }
      return [];
    }
  },
  methods: {
    ...mapActions(['getService']),
    showCreateModal() {
      this.showCreate = true;
    },
    async hideCreateModal() {
      this.showCreate = false;
      await this.getService(+this.$route.params.id);
    },
    showEditModal(state) {
      this.showEdit = true;
      this.selected = state;
    },
    async hideEditModal() {
      this.showEdit = false;
      await this.getService(+this.$route.params.id);
    },
    showDeleteModal(state) {
      this.showDelete = true;
      this.selected = state;
    },
    async hideDeleteModal() {
      this.showDelete = false;
      await this.getService(+this.$route.params.id);
    },
    makeToast(variant = null, body, title) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        hide: true,
        autoHideDelay: 3000
      });
    },
    setColorCell(color) {
      return stateColors.find( c => c.value === color );
    }
  }
}
</script>
<style lang="scss" scoped>
#listServiceState {
  margin-top: 20px;
  #color {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    p {
      margin: 0;
      margin-left: 10px;
      text-align: center;
    }
  }
}
</style>